export default __webpack_public_path__ + "static/media/afd2.21ead375.jpeg";